export const roleConstants = {
  ADMIN: 'Venture Metals Admin',
  VENTURE_METAL_STAFF: 'Venture Metals Staff',
  SUPPLIER_CONSUMER: 'Supplier/Consumer',
  SUPPLIER_CONSUMER_MAPPING: 'Supplier/Consumer mapping',
} as const

export const roleId = {
  VM_ADMIN: '1',
  VM_STAFF: '2',
  SUPPLIER_CONSUMER: '3',
  SUPPLIER_CONSUMER_MAPPING: '4',
}
